export const REJECTION_REASON_OPTIONS = Object.freeze([
  { value: "ITEM_UNAVAILABLE", label: "Item or ingredients unavailable" },
  { value: "KITCHEN_UNABLE_TO_FULFIL", label: "Kitchen unable to fulfil order" },
  { value: "DUPLICATE_ORDER", label: "Duplicate order" },
  { value: "CUSTOMER_REQUESTED", label: "Customer requested cancellation" },
  { value: "OTHER", label: "Other (custom reason)" },
]);

export const validateRejectionReason = (selection, customReason = "") => {
  const option = REJECTION_REASON_OPTIONS.find((candidate) => candidate.value === selection);
  if (!option) return { reason: "", error: "Choose a reason before rejecting this order." };
  if (selection !== "OTHER") return { reason: option.label, error: "" };
  const reason = customReason.trim();
  if (reason.length < 3 || !/\p{L}/u.test(reason)) {
    return { reason: "", error: "Enter a custom reason with at least 3 characters explaining why the order is being rejected." };
  }
  if (reason.length > 500) return { reason: "", error: "Keep the custom reason within 500 characters." };
  return { reason, error: "" };
};
